import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-keyboard",
  "use": "icon-s-keyboard-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-keyboard\"><path d=\"M21.433 4c.312 0 .567.329.567.732v11.536c0 .403-.255.732-.567.732H.567C.255 17 0 16.671 0 16.268V4.732C0 4.329.255 4 .567 4ZM21 5.857H1v10.286h20zM17 14v1H5v-1zM6 10v2H4v-2zm3 0v2H7v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zm-2-3v2h-2V7zm3 0v2h-2V7zM7 7v2H5V7zM4 7v2H2V7zm6 0v2H8V7zm3 0v2h-2V7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol